import * as signalR from "@microsoft/signalr";
import api from '../api';
import { calloutUpdateHandler, logoutUserActiveSessions, newTransferHandler, refreshCustomersHandler, refreshLocationsHandler, refreshUsersHandler, refreshWardsHandler, transferScheduleUpdated, transferUpdatedHandler,refreshTeammemberHandler } from "./handlers";
import eventNames from '../signalr/eventNames'

let hubConnection: signalR.HubConnection;

const connectSignalRHub = () => {
    hubConnection = new signalR.HubConnectionBuilder()
    .withAutomaticReconnect()
    .withUrl("/mainHub", {
        accessTokenFactory: api.getToken
    })
    .build();
}

const mappingEventsToHandlers = new Map<string, any>([
    [eventNames.refreshWards, refreshWardsHandler],
    [eventNames.refreshCustomers, refreshCustomersHandler],
    [eventNames.refreshLocations, refreshLocationsHandler],
    [eventNames.refreshUsers, refreshUsersHandler],
    [eventNames.newTransfer, newTransferHandler],
    [eventNames.transferUpdated, transferUpdatedHandler],
    [eventNames.transferScheduleUpdated, transferScheduleUpdated],
    [eventNames.logoutUserActiveSessions, logoutUserActiveSessions],
    [eventNames.refreshCallouts, calloutUpdateHandler],
    [eventNames.newTeammember, refreshTeammemberHandler]
  ]);


  const stopSignalRHub = async () => {
    if (hubConnection && hubConnection.state == signalR.HubConnectionState.Connected) {
        mappingEventsToHandlers.forEach((value: any, key: string) => {
            hubConnection.off(key);
        });
        await hubConnection.stop();
    }
}

const startSignalRHub = async () => {
    connectSignalRHub();

    try {
        await hubConnection.start();
        mappingEventsToHandlers.forEach((value: any, key: string) => {
            hubConnection.off(key);
            hubConnection.on(key, message  => value(message));
        });
    }
    catch (err) {
        alert(err);
    }
}
 
export {
    startSignalRHub,
    stopSignalRHub
}